import { useCallback, useEffect } from "react";
import { ConfirmationDialog } from "../../../ui/components/ConfirmationDialog";
import { VerificationStatus } from "../../utils/getStatus";
import { useVerificationStatusChange } from "../../hooks/useVerificationStatusChange";
import { ICompanyVerificationStatusesConfig } from "../../network";

export type Props = {
  onClose: (reason: VerificationStatus.SENT_TO_VERIFICATION | "cancel") => void;
  open: boolean;
  verificationId: string;
  value: string;
  nextStatus: VerificationStatus;
  statusesConfig: ICompanyVerificationStatusesConfig;
};

export const SendToVerificationDialog = (props: Props) => {
  const { onClose, open, verificationId, value, statusesConfig, nextStatus } =
    props;
  const [
    changeStatusResult,
    changeStatusLoading,
    changeStatusError,
    changeStatusRequest,
  ] = useVerificationStatusChange(verificationId);

  useEffect(() => {
    if (changeStatusResult) {
      onClose(VerificationStatus.SENT_TO_VERIFICATION);
    }
  }, [changeStatusResult, onClose]);

  const handleOk = useCallback(() => {
    changeStatusRequest(value);
  }, [changeStatusRequest, value]);

  return (
    <ConfirmationDialog
      title='Are you sure?'
      description={
        <span>
          After this action, the entry status will be changed to
          <span style={{ color: statusesConfig.object[nextStatus]?.color }}>
            {" "}
            {statusesConfig.object[nextStatus]?.displayName}{" "}
          </span>
        </span>
      }
      error={changeStatusError}
      confirmText='Send'
      confirmAction={handleOk}
      disabled={changeStatusLoading}
      onClose={onClose}
      isOpen={open}
      confirmButtonColor='primary'
    />
  );
};
